var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['item-container', ("background-img" + _vm.backgroundId)]},[_c('div',{staticClass:"custom-card-title"},[_vm._v(_vm._s(_vm.titleText))]),_vm._t("button")],2)}
var staticRenderFns = []

export { render, staticRenderFns }